export const salesColumns = [
  {
    label: $t('user-guidance::data::rank'),
    prop: 'index',
    width: '80'
  },
  {
    prop: 'spuImage',
    label: window.$t('user-guidance::data::table_商品图片'),
    minWidth: '120'
  },
  {
    prop: 'spuId',
    label: 'SPU_ID',
    minWidth: '120'
  },
  {
    prop: 'saleAccount',
    label: window.$t('user-guidance::data::table_销量'),
    minWidth: '120'
  },
  {
    prop: 'saleAmount',
    label: window.$t('user-guidance::data::table_销量金额'),
    minWidth: '120'
  },
  {
    prop: 'refundAccount',
    label: window.$t('user-guidance::data::table_退款量'),
    minWidth: '120'
  },
  {
    prop: 'availableInventory',
    label: window.$t('user-guidance::data::table_可用库存量'),
    width: '150'
  }
]

export const refundColumns = [
  {
    label: $t('user-guidance::data::rank'),
    prop: 'index',
    width: '80'
  },
  {
    prop: 'imageUrl',
    label: window.$t('user-guidance::data::table_商品图片'),
    minWidth: '120'
  },
  {
    prop: 'spuId',
    label: 'SPU_ID',
    minWidth: '120'
  },
  {
    prop: 'refundAccount',
    label: window.$t('user-guidance::data::table_退款量'),
    minWidth: '120'
  },
  {
    prop: 'refundAmount',
    label: window.$t('user-guidance::data::table_退款金额'),
    minWidth: '120'
  },
  {
    prop: 'saleAccount',
    label: window.$t('user-guidance::data::table_销量'),
    minWidth: '120'
  },
  {
    prop: 'refundRate',
    label: window.$t('user-guidance::data::table_退款率'),
    width: '150'
  }
]

export const elTabPaneList = [
  {
    title: window.$t('user-guidance::guide::bindShop_title'),
    name: 'isExistShop',
    index: 1,
    text: window.$t('user-guidance::guide::bindShop_text'),
    tip: window.$t('user-guidance::guide::bindShop_tip'),
    imgUrl: require('@/assets/images/emptyDefault/shop@2x.png'),
    complete: false,
    buttons: [
      {
        btnText: window.$t('user-guidance::guide::bindShop_button'),
        auth: 'stores::store::add',
        click: 'bindShop',
        buttonName: '授权店铺'
      }
    ]
  },
  {
    title: window.$t('user-guidance::guide::adAccount_title'),
    name: 'isExistAds',
    index: 2,
    text: window.$t('user-guidance::guide::adAccount_text'),
    tip: window.$t('user-guidance::guide::adAccount_tip'),
    imgUrl: require('@/assets/images/emptyDefault/Marketingaccount@2x.png'),
    complete: false,
    buttons: [
      {
        btnText: window.$t('user-guidance::guide::adAccount_button'),
        auth: 'stores::shop-site::fb-add',
        click: 'bindFackbook',
        buttonName: '设置Facebook账号'
      },
      {
        btnText: window.$t('user-guidance::guide::adAccount_button_google'),
        auth: 'stores::shop-site::google-add',
        click: 'bindGoogle',
        buttonName: '设置Google账号'
      }
    ]
  },
  {
    title: window.$t('user-guidance::guide::logistics_title'),
    name: 'isExistLogistics',
    index: 3,
    text: window.$t('user-guidance::guide::logistics_text'),
    tip: window.$t('user-guidance::guide::logistics_tip'),
    imgUrl: require('@/assets/images/emptyDefault/Logistics@2x.png'),
    complete: false,
    buttons: [
      {
        btnText: window.$t('user-guidance::guide::logistics_button'),
        auth: 'stores::shop-site::logi-add',
        click: 'bindLogistics',
        buttonName: '绑定物流商'
      }
    ]
  },
  {
    title: window.$t('user-guidance::guide::email_title'),
    name: 'isExistCs',
    index: 4,
    text: window.$t('user-guidance::guide::email_text'),
    tip: window.$t('user-guidance::guide::email_tip'),
    imgUrl: require('@/assets/images/emptyDefault/ServiceEmail@2x.png'),
    complete: false,
    buttons: [
      {
        btnText: window.$t('user-guidance::guide::email_button'),
        auth: 'stores::shop-site::email-add',
        click: 'bindEmail',
        buttonName: '设置邮箱'
      }
    ]
  },
  {
    title: window.$t('user-guidance::guide::paySetting_title'),
    name: 'isExistPaypal',
    index: 5,
    text: window.$t('user-guidance::guide::paySetting_text'),
    tip: window.$t('user-guidance::guide::paySetting_tip'),
    imgUrl: require('@/assets/images/emptyDefault/Paymentaccount@2x.png'),
    complete: false,
    buttons: [
      {
        btnText: window.$t('user-guidance::guide::paySetting_button'),
        auth: 'stores::shop-site::pay-add',
        click: 'bindPaypal',
        buttonName: '设置支付渠道'
      }
    ]
  }
]

export const actionList = [
  {
    text: window.$t('user-guidance::data::action_bindShop'),
    index: 1,
    url: require('@/assets/images/userGuidance/bind.png'),
    bgColor: 'rgba(80, 65, 171, 0.1)',
    auth: 'stores::store::add'
  },
  {
    text: window.$t('user-guidance::data::action_email'),
    index: 2,
    url: require('@/assets/images/userGuidance/email.png'),
    bgColor: 'rgba(0, 150, 136, 0.1)'
  },
  {
    text: window.$t('user-guidance::data::action_sync'),
    index: 3,
    url: require('@/assets/images/userGuidance/one.png'),
    bgColor: 'rgba(75, 159, 71, 0.1)'
  },
  {
    text: window.$t('user-guidance::data::action_orderList'),
    index: 4,
    url: require('@/assets/images/userGuidance/order.png'),
    bgColor: 'rgba(230, 82, 31, 0.1)'
  },
  {
    text: window.$t('user-guidance::data::action_newGoods'),
    index: 5,
    url: require('@/assets/images/userGuidance/new.png'),
    bgColor: 'rgba(39, 114, 240, 0.1)',
    auth: 'stores::products-info::add'
  },
  {
    text: window.$t('user-guidance::data::action_newOrder'),
    index: 6,
    url: require('@/assets/images/userGuidance/afterSale.png'),
    bgColor: 'rgba(245, 181, 68, 0.1)',
    auth: 'after-sales::after-sale-list::add'
  }
]

export const analysisList = [
  {
    text: window.$t('user-guidance::data::sales::sales_sale_title'),
    currency: 'USD',
    number: 0,
    rate: ''
  },
  {
    text: window.$t('user-guidance::data::sales::sales_order_title'),
    number: 0,
    rate: ''
  },
  {
    text: window.$t('user-guidance::data::sales::sales_sendOrder_title'),
    number: 0,
    rate: ''
  },
  {
    text: window.$t('user-guidance::data::sales::sales_saleOrder_title'),
    number: 0,
    rate: ''
  }
]

export const adverList = [
  {
    text: window.$t('user-guidance::data::ad_sales'),
    number: 0,
    rate: '',
    img: require('@/assets/images/userGuidance/ad_sales.png')
  },
  {
    text: window.$t('user-guidance::data::ad_cost'),
    number: 0,
    rate: '',
    img: require('@/assets/images/userGuidance/ad_cost.png')
  },
  {
    text: window.$t('user-guidance::data::ad_ROI'),
    number: 0,
    rate: '',
    img: require('@/assets/images/userGuidance/ad_ROI.png')
  }
]
